var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipseOuter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 137,
    viewBox: "0 0 137 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 68.5,
    r: 63.5,
    stroke: "#00644B",
    strokeWidth: 10,
    strokeMiterlimit: 16,
    strokeLinejoin: "round",
    strokeDasharray: "2 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseOuter);
export default __webpack_public_path__ + "static/media/ellipse-outer.b0476d5bc068a26fb3250fe8a79a0f74.svg";
export { ForwardRef as ReactComponent };